/** init domain config */
import Vue from 'vue'
// 设置全局API_BASE_URL
Vue.prototype.API_BASE_URL = process.env.VUE_APP_API_URL
export const DOMIAN_URL = Vue.prototype.API_BASE_URL
export const BASE_URL = Vue.prototype.API_BASE_URL
